import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function useScrollAnimation(options = {}) {
  const ref = useRef(null)
  // threshold = how far from bottom of viewport to trigger (0.05 = fires when element is 5% from bottom edge)
  // lower threshold = fires earlier = content appears sooner as user scrolls
  const { y = 20, x, duration = 0.55, delay = 0, stagger = 0.07, threshold = 0.05, childSelector } = options

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const targets = childSelector ? el.querySelectorAll(childSelector) : el
    const isSingle = !childSelector || !(targets instanceof NodeList) || targets.length === 0

    const fromVars = { opacity: 0 }
    if (y !== undefined) fromVars.y = y
    if (x !== undefined) fromVars.x = x

    const toVars = { opacity: 1, duration, delay, ease: 'power3.out' }
    if (y !== undefined) toVars.y = 0
    if (x !== undefined) toVars.x = 0

    gsap.set(isSingle ? el : targets, fromVars)

    const tween = gsap.to(isSingle ? el : targets, {
      ...toVars,
      stagger: isSingle ? 0 : stagger,
      scrollTrigger: {
        trigger: el,
        start: `top ${100 - threshold * 100}%`,
        once: true,
      },
    })

    return () => {
      tween.kill()
      ScrollTrigger.getAll().forEach((t) => {
        if (t.trigger === el) t.kill()
      })
    }
  }, [y, duration, delay, stagger, threshold, childSelector])

  return ref
}
